import React, { Component, Fragment } from 'react';
import AuthService from './services/AuthService'
import PropTypes from 'prop-types';
import { API } from 'aws-amplify';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import { remove } from 'react-icons-kit/fa/'
import ListItemIcon from '@material-ui/core/ListItemIcon';
import SvgIcon from 'react-icons-kit';
import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';
import { withSnackbar } from 'notistack';

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    marginTop: 0,
    width: 300,
  },
  menuButton:{
    margin:5
  },
});

const initialState = {
  menuCategorys: [],
  menuItems: [],
  categorizedMenuItems: [],
  inputMenuCategoryName: "",
  inputMenuCategoryPriority: "",
  inputMenuItemName: "",
  inputMenuItemNameShort: "",
  inputMenuItemCategory: "",
  inputMenuItemPrice: "",
  inputMenuItemPriority:"",
};

class Config extends Component {

  constructor(props) {
    super(props);
    this.state = initialState;
    this.authApi = new AuthService();
  }

  compare = (a, b) => {
    const priorityA = a.priority;
    const priorityB = b.priority;

    let comparison = 0;
    if (priorityA > priorityB) {
      comparison = 1;
    } else if (priorityA < priorityB) {
      comparison = -1;
    }
    return comparison;
  }

  componentWillMount(){
    this.authApi.isLogin()
    .then(
      (login) => {
        if(!login){
          this.props.history.push('/login');
        }
      }
    );

    let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
    let path = '/menu-categorys'; //replace this with the path you have configured on your API

    API.get(apiName, path).then(response => {
      console.log("response: ",response);
      response.menuCategorys.sort(this.compare);
      this.setState({
        menuCategorys: response.menuCategorys
      },() => {
        path = '/menu-items'; //replace this with the path you have configured on your API

        API.get(apiName, path).then(response => {
          console.log("response: ",response);

          let categorizedMenuItems = [];

          this.state.menuCategorys.map(n => {
            let item = {};

            let category = n.name;
            item.category = category;

            let categoryItems = response.menuItems.filter(function(item, index){
              if (item.menu_category_id === n.menu_category_id) return true;
              return false;
            });
            categoryItems.sort(this.compare);
            item.categoryItems = categoryItems;

            categorizedMenuItems.push(item);

            return true;
          })

          this.setState({
            menuItems: response.menuItems,
            categorizedMenuItems: categorizedMenuItems
          },() => {
            console.log("this.state: ", this.state);
          })

        }).catch(error => {
          console.log(error);
        })
      })
    }).catch(error => {
      console.log(error);
    })
  }

  handleChange = (event, key) => {
    this.setState({
      [key] : event.target.value
    });

  }

  handleAddMenuCategory = () => {
    let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
    let path = '/add-menu-category'; //replace this with the path you have configured on your API
    let myInit = {
      body: this.state, // replace this with attributes you need
    }

    const { enqueueSnackbar } = this.props;

    API.post(apiName, path, myInit).then(response => {
      console.log(response);
      enqueueSnackbar(response.message, {variant : 'success'});
      this.setState({
        inputMenuCategoryName: "",
        inputMenuCategoryPriority: "",
      })

      let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
      let path = '/menu-categorys'; //replace this with the path you have configured on your API

      API.get(apiName, path).then(response => {
        console.log("response: ",response);
        response.menuCategorys.sort(this.compare);
        this.setState({
          menuCategorys: response.menuCategorys
        })
      }).catch(error => {
        console.log(error);
      })

    }).catch(error => {
      console.log(error)
      if(error.message){
        enqueueSnackbar(error.message, {variant : 'error'})
      }else{
        enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
      }
    });
  }

  handleAddMenuItem = () => {
    let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
    let path = '/add-menu-item'; //replace this with the path you have configured on your API
    let myInit = {
      body: this.state, // replace this with attributes you need
    }

    const { enqueueSnackbar } = this.props;

    API.post(apiName, path, myInit).then(response => {
      console.log(response);
      enqueueSnackbar(response.message, {variant : 'success'});
      this.setState({
        inputMenuItemName: "",
        inputMenuItemNameShort: "",
        inputMenuItemCategory: "",
        inputMenuItemPrice: "",
        inputMenuItemPriority:"",
      })

      let apiName = 'MyAPIGatewayAPI';
      let path = '/menu-items'; //replace this with the path you have configured on your API

      API.get(apiName, path).then(response => {
        console.log("response: ",response);

        let categorizedMenuItems = [];

        this.state.menuCategorys.map(n => {
          let item = {};

          let category = n.name;
          item.category = category;

          let categoryItems = response.menuItems.filter(function(item, index){
            if (item.menu_category_id === n.menu_category_id) return true;
            return false;
          });
          categoryItems.sort(this.compare);
          item.categoryItems = categoryItems;

          categorizedMenuItems.push(item);

          return true;
        })

        this.setState({
          categorizedMenuItems: categorizedMenuItems
        },() => {
          console.log("this.state: ", this.state);
        })

      }).catch(error => {
        console.log(error);
      })
    }).catch(error => {
      console.log(error)
      if(error.message){
        enqueueSnackbar(error.message, {variant : 'error'})
      }else{
        enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
      }
    });
  }

  deleteMenuCategory = (menuCategoryId) => {

    let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
    let path = '/delete-menu-category'; //replace this with the path you have configured on your API
    let myInit = {
      body: {
        menuCategoryId: menuCategoryId
      }
    }

    const { enqueueSnackbar } = this.props;

    API.post(apiName, path, myInit).then(response => {

      console.log(response);

      if(response.variant === 'success'){
        let menuCategorysAfter = this.state.menuCategorys.filter((item) => {
          if(item.menu_category_id !== menuCategoryId){return true}
          return false
        })

        this.setState({
          menuCategorys: menuCategorysAfter
        })
      }

      enqueueSnackbar(response.message, {variant : response.variant});

    }).catch(error => {
      console.log(error)
      if(error.message){
        enqueueSnackbar(error.message, {variant : 'error'})
      }else{
        enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
      }
    });

  }

  deleteMenuItem = (menuItemId) => {

    let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
    let path = '/delete-menu-item'; //replace this with the path you have configured on your API
    let myInit = {
      body: {
        menuItemId: menuItemId
      }
    }

    const { enqueueSnackbar } = this.props;

    API.post(apiName, path, myInit).then(response => {

      console.log(response);
      enqueueSnackbar(response.message, {variant : 'success'});

      let menuItmsAfter = this.state.menuItems.filter((item) => {
        if(item.menu_item_id !== menuItemId){return true}
        return false
      })

      let categorizedMenuItems = [];

      this.state.menuCategorys.map(n => {
        let item = {};

        let category = n.name;
        item.category = category;

        let categoryItems = menuItmsAfter.filter(function(item, index){
          if (item.menu_category_id === n.menu_category_id) return true;
          return false;
        });
        categoryItems.sort(this.compare);
        item.categoryItems = categoryItems;

        categorizedMenuItems.push(item);

        return true;
      })

      this.setState({
        menuItems: menuItmsAfter,
        categorizedMenuItems: categorizedMenuItems
      },() => {
        console.log("this.state: ", this.state);
      })

    }).catch(error => {
      console.log(error)
      if(error.message){
        enqueueSnackbar(error.message, {variant : 'error'})
      }else{
        enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
      }
    });

  }

  render() {
    const {classes} = this.props
    const {
      menuCategorys,
      categorizedMenuItems,
      inputMenuCategoryName,
      inputMenuCategoryPriority,
      inputMenuItemName,
      inputMenuItemNameShort,
      inputMenuItemCategory,
      inputMenuItemPrice,
      inputMenuItemPriority,
    } = this.state;

    return (
      <Fragment>
        <Grid container spacing={24} className={classes.container}>
          <Grid item xs={12}>
            <Typography variant="h4" gutterBottom>
              設定
            </Typography>
          </Grid>
          <Grid item>
            <Paper className={classes.root} elevation={1}>
              <Typography variant="h6" gutterBottom>
                メニューカテゴリ追加
              </Typography>
              <ValidatorForm
                ref="form"
                onSubmit={() => this.handleAddMenuCategory()}
                onError={
                  errors => {
                    console.log(errors);
                    const { enqueueSnackbar } = this.props;
                    enqueueSnackbar('任意の項目が不正です', {variant : 'warning'});
                  }
                }
              >
                <TextValidator
                  className={classes.textField}
                  name="inputMenuCategoryName"
                  label="カテゴリ名"
                  value={inputMenuCategoryName}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'inputMenuCategoryName')}
                  required={true}
                  validators={['required']}
                  errorMessages={['必須項目を入力してください']}
                />
                <TextValidator
                  className={classes.textField}
                  name="inputMenuCategoryPriority"
                  label="順位"
                  value={inputMenuCategoryPriority}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'inputMenuCategoryPriority')}
                  required={true}
                  min="0"
                  validators={['required', 'isFloat']}
                  errorMessages={['必須項目を入力してください', '数値を入力してください']}
                  style={{width: 80}}
                />
                <Button type="submit" variant="contained" color="default" className={classes.button} style={{marginLeft:"90%", marginTop:10}}>
                  追加
                </Button>
              </ValidatorForm>

              <Typography variant="subtitle2" gutterBottom style={{marginTop: 20, marginLeft: 10}}>
                メニューカテゴリ
              </Typography>
              <Table className={classes.table} style={{marginTop: 10}}>
                <TableHead style={{backgroundColor:"#f3f3f3"}}>
                  <TableRow>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense">順位</TableCell>
                    <TableCell style={{color: "#676767"}} align="left" padding="dense">カテゴリ名</TableCell>
                    <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {menuCategorys.map(n => {
                  return(
                    <TableRow key={n.menu_category_id}>
                      <TableCell align="center" padding="dense">{n.priority}</TableCell>
                      <TableCell align="left" padding="dense">{n.name}</TableCell>
                      <TableCell align="right" padding="dense">
                        <Button
                          type="submit"
                          variant="contained"
                          color="default"
                          className={classes.button}
                          onClick={() => this.deleteMenuCategory(n.menu_category_id)}
                        >
                          <ListItemIcon><SvgIcon size={18} icon={remove}/></ListItemIcon>
                          削除
                        </Button>
                      </TableCell>
                    </TableRow>
                  )
                })}
                </TableBody>
              </Table>
            </Paper>

            <Paper className={classes.root} elevation={1} style={{marginTop:30}}>
              <Typography variant="h6" gutterBottom>
                メニュー項目追加
              </Typography>
              <ValidatorForm
                ref="form"
                onSubmit={() => this.handleAddMenuItem()}
                onError={
                  errors => {
                    console.log(errors);
                    const { enqueueSnackbar } = this.props;
                    enqueueSnackbar('任意の項目が不正です', {variant : 'warning'});
                  }
                }
              >
                <TextValidator
                  className={classes.textField}
                  name="inputMenuItemName"
                  label="品目名"
                  value={inputMenuItemName}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'inputMenuItemName')}
                  required={true}
                  validators={['required']}
                  errorMessages={['必須項目を入力してください']}
                  style={{width: 500}}
                />
                <br/>
                <TextValidator
                  className={classes.textField}
                  name="inputMenuItemNameShort"
                  label="ボタン表示名"
                  value={inputMenuItemNameShort}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'inputMenuItemNameShort')}
                  required={true}
                  validators={['required']}
                  errorMessages={['必須項目を入力してください']}
                />
                <TextValidator
                  className={classes.textField}
                  name="inputMenuItemPrice"
                  label="単価"
                  value={inputMenuItemPrice}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'inputMenuItemPrice')}
                  required={true}
                  type="number"
                  min="0"
                  validators={['required', 'isNumber', 'minNumber:0']}
                  errorMessages={['必須項目を入力してください', '整数を入力してください', '0以上の数を入力してください']}
                  style={{width: 185}}
                />
                <br/>
                <FormControl required={true} className={classes.formControl} style={{width:300,marginLeft:10, marginRight:5}}>
                  <InputLabel htmlFor="customer-type-helper">カテゴリー</InputLabel>
                  <Select
                    value={inputMenuItemCategory}
                    onChange={(e) => this.handleChange(e,'inputMenuItemCategory')}
                    input={<Input name="type" id="customer-type-helper" />}
                  >
                  {menuCategorys.map(n => {
                    return(
                      <MenuItem key={n.menu_category_id} value={n.menu_category_id}>{n.name}</MenuItem>
                    )
                  })}
                  </Select>
                </FormControl>
                <TextValidator
                  className={classes.textField}
                  name="inputMenuItemPriority"
                  label="順位"
                  value={inputMenuItemPriority}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'inputMenuItemPriority')}
                  required={true}
                  min="0"
                  validators={['required', 'isFloat']}
                  errorMessages={['必須項目を入力してください', '数値を入力してください']}
                  style={{width: 80}}
                />
                <Button type="submit" variant="contained" color="default" className={classes.button} style={{marginLeft:"90%", marginTop:10}}>
                  追加
                </Button>
              </ValidatorForm>
              {categorizedMenuItems.map(n => {
                return(
                  <Fragment key={n.category}>
                    <Typography variant="subtitle2" gutterBottom style={{marginTop: 20, marginLeft: 10}}>
                      {n.category}
                    </Typography>
                    <Table className={classes.table} style={{marginTop: 10}}>
                      <TableHead style={{backgroundColor:"#f3f3f3"}}>
                        <TableRow>
                          <TableCell style={{color: "#676767"}} align="center" padding="dense">順位</TableCell>
                          <TableCell style={{color: "#676767", maxWidth: 270}} align="left" padding="dense">品目名</TableCell>
                          <TableCell style={{color: "#676767"}} align="left" padding="dense">ボタン表示名</TableCell>
                          <TableCell style={{color: "#676767"}} align="center" padding="dense">単価</TableCell>
                          <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                      {n.categoryItems.map(m => {
                        return (
                          <TableRow key={m.menu_item_id}>
                            <TableCell align="center" padding="dense">{m.priority}</TableCell>
                            <TableCell align="left" padding="dense" style={{maxWidth: 270}}>{m.name}</TableCell>
                            <TableCell align="left" padding="dense">{m.name_short}</TableCell>
                            <TableCell align="center">{m.price}</TableCell>
                            <TableCell align="right" padding="dense">
                              <Button
                                type="submit"
                                variant="contained"
                                color="default"
                                className={classes.button}
                                onClick={() => this.deleteMenuItem(m.menu_item_id)}
                              >
                                <ListItemIcon><SvgIcon size={18} icon={remove}/></ListItemIcon>
                                削除
                              </Button>
                            </TableCell>
                          </TableRow>
                        )
                      })}
                    </TableBody>
                  </Table>
                </Fragment>
                )
              })}
            </Paper>
          </Grid>
        </Grid>
      </Fragment>
    );
  }
}

Config.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withSnackbar(withRouter(withStyles(styles, { withTheme: true })(Config)));
